<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible="visible"
      width="90%"
      :title="$l('dialog_title_mergeShipment') || '生成发运单'"
      :close-on-click-modal="false"
      :before-close="close"
      v-el-dialog-drag
      append-to-body
    >
      <Main ref="main" @choose-change="chooseShipment" />
      <span slot="footer">
        <el-button size="small" @click="close">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="buildShipment()">
          {{ $l('btn_create_shipment') || '新建发运单' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="!selectedShipmentCode"
          @click="buildShipment(selectedShipmentCode)"
        >
          {{ $l('btn_merge_shipment') || '合并到已有发运单' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'

export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    rows: { type: Array, default: () => [] },
  },
  data() {
    return { selectedShipmentCode: '' }
  },
  watch: {
    visible(val) {
      if (!val) this.reset()
    },
  },
  methods: {
    chooseShipment(row) {
      this.selectedShipmentCode = row?.shipmentCode || ''
    },
    reset() {
      this.selectedShipmentCode = ''
    },
    close() {
      this.reset()
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    buildShipment(shipmentCode = '') {
      const count = this.rows.length
      const actionText = shipmentCode
        ? this.$l('btn_merge_shipment') || '合并到已有发运单'
        : this.$l('btn_create_shipment') || '新建发运单'
      const confirmText = shipmentCode
        ? `${this.$l('tips_confirm_generate_prefix') ||
            '确认为选中的'} ${count} ${this.$l(
            'tips_confirm_merge_shipment_suffix'
          ) || '条补货计划合并到已有发运单？'}`
        : `${this.$l('tips_confirm_generate_prefix') ||
            '确认为选中的'} ${count} ${this.$l(
            'tips_confirm_generate_suffix'
          ) || '条补货计划生成发运单？'}`

      this.$confirm(confirmText, actionText, {
        type: 'warning',
        confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
      })
        .then(() => {
          if (this.loadingOpen()) return null
          const payload = {
            listAmzReplenishmentCode: this.rows.map(
              (item) => item.amzReplenishmentCode
            ),
          }
          if (shipmentCode) payload.shipmentCode = shipmentCode
          return this.$api.ecomShipmentInfoBuildApi(payload).catch(() => null)
        })
        .then((res) => {
          this.loadingClose()
          if (!res) {
            this.$message.error(
              this.$l('message_request_failed') || '请求失败，请稍后重试'
            )
            return
          }

          const { status, msg } = res
          const error = status !== 200

          this.$message({
            showClose: true,
            type: error ? 'error' : 'success',
            message: msg,
          })

          if (error) return

          this.reset()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
